import Backbone, {ViewOptions} from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom/client';

import TimerList from 'notebook/protocols/timers/TimerList';
import TimerStore from 'notebook/protocols/timers/TimerStore';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

class TimerView extends Backbone.View<Backbone.Model> {
  reactRoot: ReactDOM.Root | null = null;

  override initialize(options: ViewOptions<Backbone.Model>): void {
    this.render = this.render.bind(this);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    TimerStore.addChangeListener(this.render);
  }

  override remove(): Backbone.View<Backbone.Model> {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    TimerStore.removeChangeListener(this.render);
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
    });
    return this;
  }

  override render(): this {
    const component = <TimerList {...TimerStore.getState()} />;
    this.reactRoot = renderToDOM(component, this.el, this.reactRoot);
    return this;
  }
}

export default TimerView;
